import { render } from "./RectangleGrouping.vue?vue&type=template&id=5eb6db7e&scoped=true"
import script from "./RectangleGrouping.vue?vue&type=script&lang=js"
export * from "./RectangleGrouping.vue?vue&type=script&lang=js"

import "./RectangleGrouping.vue?vue&type=style&index=0&id=5eb6db7e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eb6db7e"]])

export default __exports__